import { useQuery } from 'react-query'
import { retrieveAddress } from '../../../utils/badaAppointmentApi'

export const useRetrieveAddress = (refinementId, enabled = true) =>
  useQuery(
    ['retrieveAddress', refinementId],
    () => retrieveAddress(refinementId),
    { retry: 2, enabled }
  )
